import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
//Material imports
import IconButton from "@material-ui/core/IconButton";
import Send from "@material-ui/icons/Send";
import withStyles from "@material-ui/core/styles/withStyles"; //Limitles imports

import { withi18n } from "../hocs/i18n";

var ResponseBox = function ResponseBox(_ref) {
  var onClickHandle = _ref.onClickHandle,
      t = _ref.t,
      classes = _ref.classes,
      scrollConversationCallback = _ref.scrollConversationCallback,
      toggleInputFocus = _ref.toggleInputFocus,
      onTypingHandler = _ref.onTypingHandler;

  var _React$useState = React.useState({
    response: "",
    showSend: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localState = _React$useState2[0],
      setLocalState = _React$useState2[1];

  var handleResponseChange = function handleResponseChange(event) {
    var response = event.target.value;
    response = response.trim() === "" ? response.trim() : response;
    var showSend = response.trim().length > 0 ? true : false;
    setLocalState({
      response: response,
      showSend: showSend,
      focusClassName: ""
    });

    if (typeof onTypingHandler === "function") {
      onTypingHandler(showSend);
    }
  };

  var handleResponseSubmit = function handleResponseSubmit() {
    onClickHandle(localState.response, updateResponseBox);
  };

  var updateResponseBox = function updateResponseBox() {
    setLocalState({
      response: "",
      showSend: false
    });

    if (typeof onTypingHandler === "function") {
      onTypingHandler(false);
    }
  };

  var handleFocus = function handleFocus() {
    //this is to handle the virtual keyboard. we scroll to the top of the page
    //because for mobile we have an absolute positioned textbox
    var isAndroid = /(android)/i.test(navigator.userAgent);

    if (isAndroid) {
      toggleInputFocus(true);
    }
  };

  var handleBlur = function handleBlur() {
    //see above, once the textbox closes, scroll to the bottom
    scrollConversationCallback(); //in case the user click the send button, allow 100 to try and capture that
    //without this what happens is the UI resizes and the send button click is missed

    setTimeout(function () {
      return toggleInputFocus(false);
    }, 100);
  };

  var showSend = localState.showSend,
      response = localState.response;
  var sendVisible = classes.sendVisible,
      sendHidden = classes.sendHidden;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("textarea", {
    placeholder: t("Type to respond..."),
    onChange: handleResponseChange,
    value: response,
    className: classes.textarea,
    onFocus: handleFocus,
    onBlur: handleBlur // ref={el => (responseBox = el)}
    ,
    id: "responseTextArea",
    "aria-label": t("Type to respond")
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.sendIconContainer && showSend ? sendVisible : sendHidden
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Menu",
    onClick: handleResponseSubmit,
    component: "div",
    id: "responseSubmitButton",
    className: classes.sendButton
  }, /*#__PURE__*/React.createElement(Send, null))));
};

var styles = function styles(theme) {
  return {
    container: {
      color: "".concat(theme.palette.primary.contrast, " !important"),
      resize: "none",
      border: "none",
      display: "flex",
      maxHeight: 50,
      boxShadow: "0 -2px 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.06)"
    },
    textarea: {
      width: "100%",
      color: "".concat(theme.palette.contrast.main, " !important"),
      resize: "none",
      border: "none",
      padding: 15,
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      margin: "0",
      maxHeight: 20,
      "&:focus": {
        outline: "none",
        backgroundColor: "#fff !important",
        boxShadow: "0 0 100px 0 rgba(150, 165, 190, 0.24) !important"
      }
    },
    //iOS only stylings.. i hope :)
    "@supports (-webkit-overflow-scrolling: touch)": {
      textarea: {
        fontSize: 16
      }
    },
    sendIconContainer: {
      backgroundColor: "white"
    },
    sendHidden: {
      display: "none",
      transition: "opacity 1s ease-out",
      opacity: "0"
    },
    sendVisible: {
      opacity: "1",
      display: "block"
    },
    sendButton: {
      color: theme.palette.buttons ? theme.palette.buttons.send.color : theme.palette.contrast.main
    }
  };
};

export default withStyles(styles, {
  withTheme: true
})(withi18n(ResponseBox, "Response"));